export default {"src":"/_next/static/image/src/components/icons/history.aad283d591b42eb12cf16e8a3997f706.svg","height":109,"width":123};